import { Component, OnInit, Input } from '@angular/core';
import { UserAccessService } from '../../../services/user-access.service';
import { RolePermission } from '../../../models/Securable';

@Component({
    selector: 'sec-lock',
    templateUrl: './securable-lock-component.html'
    //styleUrls: ['./header.component.scss']
})
export class SecurableLockComponent implements OnInit {
    @Input('SEC') SecurableName: string; //Keep consistency [SEC] = securable name
    @Input('SEID') salesEntityID: number; //Optional Sales Entity ID for specific permissions
    @Input('MID') merchantID: number; //Optional merchant ID for specific permissions
    @Input('Editing') Editing: boolean; //Editing t/f
    @Input('SubID') subObjID: number; //Optional sub object ID when present must be sent along with the request for securables
    @Input('CHANGE') change: boolean; //Optional input to force change control to trigger can be flipped on/off (places where we can't use editing)
    
    private ParentObjectID: number;
    public isLocked: boolean = false;
    public get isEditing(): boolean {
        return this.Editing;
    }

    constructor(
        public userSvc: UserAccessService
    ) {
        //construct stuff
    }

    ngOnChanges() {
        this.BuildComponent();
    }

    ngOnInit() {
        //console.log("Lock Component SUB ID:",this.SecurableName, this.subObjID);
        this.BuildComponent();
    }
    /**
     * Builds the lock if the securable has pending changes.
     */
    BuildComponent() {
        this.userSvc.GetSecurableObjectByName(this.SecurableName, undefined, this.salesEntityID, this.merchantID, true).then(resp => {
            //console.log("LOCK COMP - SEC NAME:",this.SecurableName, resp);
            if (resp) {
                if (this.subObjID) {
                    //console.log("LockComponent - Has SubObjID: ", this.subObjID);
                    //Must fetch sub object level permissions
                    this.FetchSubObjectSecurable(resp).then(specificResp => {
                        //console.log("LockComponent - SubID Role Permission: ", specificResp);
                        //Adjust this element based on the SUB OBJ securable
                        this.HandleResponse(specificResp);
                    });
                } else {
                    //console.log("No SubObject, RolePermission:",resp);
                    //No sub object(s) adjust like normal
                    this.HandleResponse(resp);
                }
            } else { console.warn("Securable Lock component is not getting an object to act on."); }
        });
    }
    /**
     * Adjusts the lock based on the passed in role.
     * @param resp The role permission response to act based on.
     */
    private HandleResponse(resp: RolePermission) {
      
        if (resp.HasPendingChange) {
            this.isLocked = true;
        } else {
            this.isLocked = false;
        };
    }

    /**
    * Takes the ParentID from the passed in permission and returns the new permissions for 
    * the sub object ID + ParentID from the securables_Get sproc
    * @param perm The original permission that gives us the ParentObjID
    */
    private async FetchSubObjectSecurable(perm: RolePermission): Promise<RolePermission> {
        if (!this.ParentObjectID) { this.ParentObjectID = perm.ObjectSecurableID; }
        return await this.userSvc.GetSecurableObjectByName(this.SecurableName, undefined, this.salesEntityID, this.merchantID, true, this.subObjID, this.ParentObjectID);
    }
}